const addOriginParam = params => path => {
  return params.has('origin') ? `${path}?origin=${params.get('origin')}` : path;
};

export default addOriginParam;
